export enum ChromosomeLocationColor {
	Red = "Red",
	Green = "Green",
	Blue = "Blue",
	Orange = "Orange",
	Yellow = "Yellow",
}
